import CDNClient, { EnvType } from '@cmao/cdn-uploader';
import { Toast } from 'vant';
import { config } from './config';
import { fetchUploadPoster } from '@/apis/marketing';

interface IPosterUpload {
  fileurl:string;
  bucket:string;
  key:string;
}

// config.env与上传组件的env对应
const UploadEnv:{ [key:string]:EnvType } = {
  'local': 'test',
  'development': 'dev',
  'test': 'test',
  'staging': 'staging',
  'production': 'prod',
};
// 上传实例
let uploaderClient:CDNClient | undefined;

/**
 * @description 上传CDN
 * @author Wynne
 * @date 2021-03-24
 * @param {Blob} file 文件名
 * @param {IUploadConfig} config 上传配置
 */
export async function CdnUpload(file:File, progressFn?:(progress:any) => void):Promise<string> {
  return new Promise((resolve, reject) => {
    if (!uploaderClient) {
      uploaderClient = new CDNClient({
        env: UploadEnv[config.env],
        projectName: 'group_buy_activity',
      });
    }
    if (!file) {
      Toast('请选择需要上传的文件');
      return;
    }
    uploaderClient.create(file, {
      onsuccess: (result) => {
        const { url } = result;
        resolve(url);
      },
      onprogress: (progress:any) => {
        if (progressFn) { progressFn(progress); }
      },
      onerror: (error) => {
        reject(error);
      },
    }).then((uploader) => {
      if (uploader) {
        uploader.start();
      }
    }).catch((err) => {
      reject(err);
    });
  });
}

/**
 * @description 海报上传
 * @author Wynne
 * @date 2021-03-25
 * @export
 * @param {File} file
 * @param {(progress:any) => void} [progressFn]
 * @return {*}  {Promise<string>}
 */
export async function PosterUpload(data:FormData, bucketUrl:string, progressFn?:(progress:any) => void):Promise<IPosterUpload> {
  return new Promise((resolve, reject) => {
    fetchUploadPoster(data).then((res) => {
      if (res.status === 200) {
        console.log(res);
        if (progressFn)
          progressFn({ total: { percent: 100 } });
        resolve({
          fileurl: `${bucketUrl}/${res.data.key}`,
          bucket: bucketUrl,
          key: res.data.key,
        });
      }
    }).catch((error:any) => {
      reject(error);
    });
  });
}
